<sm-dialog-template>
  <sm-admin-dialog-template [newCredential]="data.credentials"></sm-admin-dialog-template>
</sm-dialog-template>
